import { combineReducers, configureStore } from "@reduxjs/toolkit";
import commonReducer from "../store/slices/common.slice";
import { Auth } from "../auth/auth";
import { ROUTES } from "../common/constants";
import userInfoReducer from "./slices/userInfo.slice";
export const ROOT_REDUCER_ACTIONS = {
  LOGOUT: "LOGOUT",
};

const combinedReducer = combineReducers({
  commonReducer: commonReducer,
  userInfoReducer: userInfoReducer,
});

const rootReducer = (state: any, action: any) => {
  switch (action.type) {
    case ROOT_REDUCER_ACTIONS.LOGOUT:
      var processedFiles =
        state?.vscDashboardReducer?.vmoBot?.fileUpload?.processedFiles;
      // if (Array.isArray(processedFiles) && processedFiles?.length > 0) {
      //   deleteFilesFromGcs({
      //     file_names: processedFiles,
      //     feature: "talk_to_contract",
      //   });
      // }
      const auth = Auth.getInstance();
      auth.discardSession();
      window.location.replace(ROUTES.login);
      state = {};
      break;
    default:
      break;
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: {
    rootReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
